import React, { Component } from "react";
import {
  Button,
  Card,
  FormControl,
  IconButton,
  OutlinedInput,
  InputAdornment,
  InputLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Link } from "react-router-dom";
// import { login } from "../actions/postActions";
import { makeStyles } from "@material-ui/core/styles";
import client from "../api/client";
import { Redirect } from "react-router-dom";

import qs from "qs";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      institution: "",
      email: "",
      password: "",
      passwordAgain: "",
      showPassword: false,
      showPasswordAgain: false,
      errorMessage: "",
      successMessage: "",
      institutions: [],
      isAuthenticated: false,
      user: this.props.user,
      resetSuccess: false,
    };
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.reset = this.reset.bind(this);
    this.resetReq = this.resetReq.bind(this);
  }

  componentDidMount() {
    document.title = "Reset Password | Appleby Wellness";
  }

  componentWillReceiveProps(nextState) {
    // load in all calendar events on init
    // console.log('next state', nextState.admin)
    this.setState({
      user: nextState.user,
    });
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  handleClickShowPasswordAgain = () => {
    this.setState((state) => ({ showPasswordAgain: !state.showPasswordAgain }));
  };

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  validateInput = () => {
    if (!this.state.email || this.state.email.length === 0)
      return "Please enter your email address";
    if (!this.state.password || this.state.password.length === 0)
      return "Please enter a password";
    return "valid";
  };

  /**
   * Mirrors the server's policy (routers/user.js assertPasswordPolicy).
   *
   * There was previously no policy at all — the `minLength: 7` on the User
   * schema was an unrecognised Mongoose option and silently did nothing.
   * Checking here means the user sees the requirement before submitting rather
   * than as a rejected request.
   *
   * @returns {string|null} an error message, or null when acceptable
   */
  passwordPolicyError = (password) => {
    if (typeof password !== "string" || password.length < 12) {
      return "Password must be at least 12 characters.";
    }
    if (!/[a-zA-Z]/.test(password) || !/[0-9]/.test(password)) {
      return "Password must contain at least one letter and one number.";
    }
    return null;
  };

  reset = () => {
    // check that passwords match or give error.
    const policyError = this.passwordPolicyError(this.state.password);
    if (policyError) {
      this.setState({ errorMessage: policyError });
      return;
    }
    if (this.state.password !== this.state.passwordAgain) {
      this.setState({
        errorMessage: "Passwords do not match!",
      });
    } else {
      var promise = new Promise((resolve) => {
        // get token and ID from URL
        var payload = {
          token: qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
          }).token,
          userId: qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
          }).id,
          password: this.state.password,
        };
        console.log(payload);
        this.resetReq(resolve, payload);
      });
      return promise;
    }
  };

  // login = () => {
  //   var promise = new Promise((resolve) => {
  //     var payload = {
  //       email: this.state.email,
  //       password: this.state.password,
  //     };
  //     console.log(payload);
  //     this.loginReq(resolve, payload);
  //   });
  //   return promise;
  // };

  resetReq = (resolve, payload) => {
    // skipAuthRedirect: an expired reset token comes back 400, but the user is
    // not signed in here at all — the global handler must not intervene.
    client
      .post("/users/resetpassword", payload, { skipAuthRedirect: true })
      .then(() => {
        resolve("Success! You will now be redirected to login..");
        this.setState({
          errorMessage: "",
          successMessage:
            "Your password has been reset. Redirecting you to sign in...",
        });
        setTimeout(() => {
          this.setState({ resetSuccess: true });
        }, 2000);
      })
      .catch((error) => {
        // WEAK_PASSWORD carries the specific requirement that failed;
        // INVALID_RESET_TOKEN means the link expired (they last one hour).
        this.setState({
          errorMessage:
            error.code === "INVALID_RESET_TOKEN"
              ? "This reset link has expired. Please request a new one."
              : error.message,
        });
        resolve(error.message);
      });
  };

  render() {
    const classes = {
      root: {},
      card: {},
      leftAlign: {
        textAlign: "left",
      },
    };
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          minHeight: "90vh",
        }}
        className={classes.root}
      >
        <Grid
          container
          alignItems="center"
          direction="column"
          justify="space-between"
        >
          <Grid item>
            <div />
          </Grid>
          <Card
            style={{
              boxShadow: "none",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              padding: 30,
              minWidth: 400,
            }}
          >
            <Grid style={{}} container direction={"column"} spacing={3}>
              <Grid item style={{ textAlign: "left" }}>
                <Typography variant="h4">Reset Password</Typography>
              </Grid>
              <Grid item style={{ textAlign: "left" }}>
                <Typography variant="body2" style={{ color: "gray" }}>
                  Please enter your new password twice.
                </Typography>
              </Grid>
              {this.state.errorMessage.length > 0 && (
                <Grid item style={{ textAlign: "left" }}>
                  <Typography variant="body2" style={{ color: "red" }}>
                    {this.state.errorMessage}{" "}
                  </Typography>
                </Grid>
              )}
              {this.state.successMessage.length > 0 && (
                <Grid item style={{ textAlign: "left" }}>
                  <Typography variant="body2" style={{ color: "green" }}>
                    {this.state.successMessage}{" "}
                  </Typography>
                </Grid>
              )}
              <Grid item>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>New Password</InputLabel>
                  <OutlinedInput
                    type={this.state.showPassword ? "text" : "password"}
                    labelWidth={this.props.language == "en" ? 120 : 180}
                    value={this.state.password}
                    onChange={this.handleChange("password")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Verify New Password</InputLabel>
                  <OutlinedInput
                    type={this.state.showPasswordAgain ? "text" : "password"}
                    labelWidth={this.props.language == "en" ? 170 : 230}
                    value={this.state.passwordAgain}
                    onChange={this.handleChange("passwordAgain")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPasswordAgain}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPasswordAgain ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item container justify="center">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.reset}
                  disabled={
                    (this.state.password.length > 5 &&
                      this.state.passwordAgain.length) > 5
                      ? false
                      : true
                  }
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Card>
          <Link
            id="ResetPassword"
            to={"/forgot"}
            style={{ textDecoration: "none" }}
          >
            <Typography
              variant="body2"
              style={{ color: "gray", marginTop: 25 }}
            >
              Request Reset Link
            </Typography>
          </Link>
          <Grid item>
            <div />
          </Grid>
        </Grid>
        {this.state.resetSuccess && <Redirect to="/login" />}
      </div>
    );
  }
}

export default ResetPassword;
